import { getInternalMetas } from "../../internal/metas.js";
import { isEmpty, isNull } from "../../utils/is.js";
import { deepEqual } from "../../utils/deepEqual.js";
import { getCurrentTimestamp, timestampToIsoString } from "../../utils/date.js";
import "../../utils/logLevels.js";
import { stringifyObjectValues } from "../../utils/json.js";
import { captureMetas } from "../../metas/capture.js";
import "../../transports/const.js";
import { addItemToUserActionBuffer } from "../userActions/initialize.js";
import { defaultLogArgsSerializer } from "./const.js";
//#region src/api/logs/initialize.ts
function initializeLogsAPI({ internalLogger, config, metas, transports, tracesApi, userActionsApi }) {
	var _config$logArgsSerial;
	internalLogger.debug("Initializing logs API");
	let lastPayload = null;
	const logArgsSerializer = (_config$logArgsSerial = config.logArgsSerializer) !== null && _config$logArgsSerial !== void 0 ? _config$logArgsSerial : defaultLogArgsSerializer;
	const pushLog = (args, { context, level, skipDedupe, spanContext, timestampOverwriteMs } = {}) => {
		try {
			if (!getInternalMetas(metas).shouldCapture()) return;
			const ctx = stringifyObjectValues(context);
			const payload = {
				message: logArgsSerializer(args),
				level: level !== null && level !== void 0 ? level : "log",
				context: isEmpty(ctx) ? void 0 : ctx,
				timestamp: timestampOverwriteMs ? timestampToIsoString(timestampOverwriteMs) : getCurrentTimestamp(),
				trace: spanContext ? {
					trace_id: spanContext.traceId,
					span_id: spanContext.spanId
				} : tracesApi.getTraceContext()
			};
			const testingPayload = {
				message: payload.message,
				level: payload.level,
				context: payload.context
			};
			if (!skipDedupe && config.dedupe && !isNull(lastPayload) && deepEqual(testingPayload, lastPayload)) {
				internalLogger.debug("Skipping log push because it is the same as the last one\n", payload);
				return;
			}
			const previousPayload = lastPayload;
			const meta = captureMetas(metas);
			if (lastPayload !== previousPayload && !skipDedupe && config.dedupe && deepEqual(testingPayload, lastPayload)) return;
			lastPayload = testingPayload;
			const item = {
				type: "log",
				payload,
				meta
			};
			internalLogger.debug("Pushing log\n", item);
			if (!addItemToUserActionBuffer(userActionsApi.getActiveUserAction(), item)) transports.execute(item);
		} catch (err) {
			internalLogger.error("Error pushing log\n", err);
		}
	};
	return { pushLog };
}
//#endregion
export { initializeLogsAPI };

//# sourceMappingURL=initialize.js.map